export function attachCookiebotParentListeners({ iframe }) {
  global.window.addEventListener('CookiebotOnAccept', () => {
    // Catch initial pageload - frames can be loading still
    setTimeout(() => {
      parseCookiebotConsent(iframe);
    }, 2500);
  });

  global.window.addEventListener('CookiebotOnDecline', () => {
    parseCookiebotConsent(iframe);
  });
}

function parseCookiebotConsent(iframe) {
  if (typeof global.Cookiebot !== 'object')
    return;

  iframe.iFrameResizer.sendMessage({
    event: 'COOKIEBOT_SET',
    payload: {
      consent: global.Cookiebot.consent,
    },
  });
}
